import { ClassImporterExporter } from "@app/shared/resources/class-importer-exporter.service";

export enum ServicePlanFeatureKey {
    SECURITY_NOTIFICATIONS = "security_notifications",
    BASIC_CONTROL = "basic_control",
    SECURITY_MONITORING = "security_monitoring",
    SECURITY_CONTROL = "security_control",
    CELLULAR = "cellular",
    TWO_WAY_CALLING = "two_way_calling",
}

export interface ServicePlanFeature {
    id: number;

    featureKey: ServicePlanFeatureKey;
    featureName: string;
    description: string;
}

export interface ServicePlanFeatureData {
    id: number;

    feature_key: ServicePlanFeatureKey;
    feature_name: string;
    description: string;
}

export class ServicePlanFeatureHelper {
    static readonly importMap = [
        { i: "id", o: "id" },
        { i: "feature_key", o: "featureKey" },
        { i: "feature_name", o: "featureName" },
        { i: "description", o: "description" },
    ] as const;

    static fromDbObject(data: ServicePlanFeatureData): ServicePlanFeature {
        return ClassImporterExporter.importObject(data, ServicePlanFeatureHelper.importMap);
    }

    static toDbObject(feature: ServicePlanFeature): ServicePlanFeatureData {
        return ClassImporterExporter.exportObject(feature, ServicePlanFeatureHelper.importMap);
    }
}
